// import { CLIENT_SECRET, PARTNER_ID } from '../constants/globalConstants'
import { getPartnerDetails } from '../utils/helper'
// import { getUserSecret } from './secrets'

// const user = window.location.toString().split('/')[3]
export const getConfigDetails = () => {
  // switch ('demo') {
  // switch ('preStage') {
  // switch ('staging') {
    // switch ('preprod') {
    switch ('live') {
    case 'demo': //staging2
      return {
        // baseURL: 'https://demo-api.parkengage.com/',
        // PARTNER_ID: PARTNER_ID,
        // clientSecret: CLIENT_SECRET,

        baseURL: 'https://demo-api.parkengage.com/',
        partnerUrl: 'https://demo-admin.parkengage.com',
        adminUrl: 'https://demo-admin.parkengage.com',
        checkInUrl: 'https://demo-checkin.parkengage.com',
        transientURL: 'https://demo-transient.parkengage.com',
        ticketURL: 'https://demo-getreceipt.parkengage.com',
        portalURL: 'https://demo-customerportal.parkengage.com/navigating',
        portalBASEURL: 'https://demo-customerportal.parkengage.com',
        FACILITY_ID: 1,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '356560',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'vikrant-tyagi356560',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',

      }
    case 'preStage': //staging
      return {
        baseURL: 'https://pre-stage-api.parkengage.com/',
        checkInUrl: 'https://pre-stage-checkin.parkengage.com',
        adminUrl: 'https://pre-stage-admin.parkengage.com',
        transientURL: 'https://pre-stage-transient.parkengage.com',
        ticketURL: 'https://pre-stage-getreceipt.parkengage.com',
        partnerUrl: 'https://pre-stage-admin.parkengage.com',
        portalURL: 'https://pre-stage-customerportal.parkengage.com/navigating',
        portalBASEURL: 'https://pre-stage-customerportal.parkengage.com',
        FACILITY_ID: 195,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '356560',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'vikrant-tyagi356560',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',

      }
    case 'staging': //staging
      return {


        baseURL: 'https://staging-api.parkengage.com/',
        adminUrl: 'https://staging-admin.parkengage.com',
        checkInUrl: 'https://staging-checkin.parkengage.com',
        transientURL: 'https://staging-transient.parkengage.com',
        ticketURL: 'https://staging-getreceipt.parkengage.com',
        portalURL: 'https://staging-customerportal.parkengage.com/navigating',
        partnerUrl: 'https://staging-admin.parkengage.com',
        portalBASEURL: 'https://staging-customerportal.parkengage.com',
        FACILITY_ID: 195,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '356560',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'vikrant-tyagi356560',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',
        // CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : 'lAn4gbbzQSdkspdWJo0phdrDB',

      }
    case 'preprod': //staging
      return {
        // baseURL: 'https://staging-api.parkengage.com/',
        // FACILITY_ID: 1,
        // FULL_SEASON: '502',
        // HALF_SEASON: '506',
        // SIX_PACK: '507',
        // clientSecret: CLIENT_SECRET,

        baseURL: 'https://preprod-api.parkengage.com/',
        adminUrl: 'https://preprod-admin.parkengage.com',
        checkInUrl: 'https://preprod-checkin.parkengage.com',
        transientURL: 'https://preprod-transient.parkengage.com',
        ticketURL: 'https://preprod-getreceipt.parkengage.com',
        partnerUrl: 'https://preprod-admin.parkengage.com',
        portalURL: 'https://preprod-customerportal.parkengage.com/navigating',
        portalBASEURL: 'https://preprod-customerportal.parkengage.com',
        FACILITY_ID: 195,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '3307',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'parking-payments3307',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',

      }
    case 'live': //live
      return {
        baseURL: 'https://api.parkengage.com/',
        adminUrl: 'https://partner.parkengage.com',
        checkInUrl: 'https://checkin.parkengage.com',
        transientURL: 'https://transient.parkengage.com',
        ticketURL: 'https://getreceipt.parkengage.com',
        portalURL: 'https://customerportal.parkengage.com/navigating',
        partnerUrl: 'https://partner.parkengage.com',
        portalBASEURL: 'https://customerportal.parkengage.com',
        FACILITY_ID: 32,
        FULL_SEASON: '80',
        HALF_SEASON: '81',
        SIX_PACK: '82',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '3307',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'parking-payments3307',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',

      }
  }
}
